'use strict';

(function () {
  'use strict';

  angular.module('vnext').component('msTimeseriesChart', {
    bindings: {
      chartData: '<'
    },
    templateUrl: 'vnext/templates/time-series-chart.html',
    controller: TimeSeriesChartController
  });

  TimeSeriesChartController.$inject = ['chartJSSvc'];

  function TimeSeriesChartController(chartJSSvc) {
    var vm = this;
    vm.chartJSData = [];
    vm.$onChanges = plotItAll;
    vm.dotStyles = function (index) {
      return chartJSSvc.trackerDotStyles(index, '25px');
    };

    function plotItAll() {
      if (vm.chartData && vm.chartData.length) {
        // Set Options, Series, Labels, Data for ChartJS to work.
        vm.chartJSOptions = chartJSSvc.assessmentOptions();
        vm.colors = chartJSSvc.assessmentColors;
        vm.chartJSSeries = chartJSSvc.buildChartJSSeries(vm.chartData).sort();
        vm.chartJSLabels = chartJSSvc.createTimeSeriesLabels(vm.chartData);
        vm.chartData.forEach(function (chartData) {
          return vm.chartJSData.push(_.map(chartData.data, 'value'));
        });
      }
    }
  }
})();